import React, { useRef } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { useTranslation } from "react-i18next";
import { SectionHeading } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";
import {
  Container,
  ContentWithVerticalPadding,
} from "components/misc/Layouts.js";
import { ReactComponent as CheckboxIcon } from "feather-icons/dist/icons/check-circle.svg";
import { ReactComponent as SvgDecoratorBlob1 } from "images/dot-pattern.svg";
import leaseBusinessDiagram from "images/business/lease-business.png";
import BgTitle from "components/title/BgTitle";
import LeaseBusinessMobileView from "./LeaseBusinessMobileView";

const BgWrapper = styled.div`
  ${tw`fancy-feature-mask`}
`;
const Row = tw.div`flex flex-col lg:flex-row justify-between items-center lg:pt-16 max-w-screen-2xl mx-auto sm:px-8`;
const Column = tw.div``;
const TextColumn = tw(
  Column
)`mr-auto lg:mr-0 max-w-lg lg:max-w-xl xl:max-w-2xl`;
const Heading2 = tw(SectionHeading)`text-left leading-snug xl:text-2xl`;
const Description = tw(SectionDescription)`mt-4 text-sm text-gray-700`;
const FeatureList = tw.ul`mt-12 leading-loose`;
const Feature = tw.li`flex items-center`;
const FeatureIcon = tw(CheckboxIcon)`w-5 h-5 text-ncc`;
const FeatureText = tw.p`ml-2 text-sm font-medium text-gray-700`;
const ContactInfo = tw.div`mt-8 rounded-lg text-left`;
const ContactText = tw.p`text-sm font-medium text-gray-700`;

const ImageColumn = tw(Column)`ml-auto lg:mr-0 relative mt-16 lg:mt-0 lg:ml-32`;
const ImageContainer = tw.div`relative z-40 transform xl:-translate-x-24 xl:-translate-y-16`;
const Image = tw.img`
  max-w-full w-3/4 sm:w-1/2 md:w-2/3 lg:w-auto rounded-t sm:rounded relative z-20
`;
const Offsetbackground = tw.div`absolute inset-0 bg-gray-300 rounded xl:-mb-8`;
const ImageDecoratorBlob = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none z-10 absolute right-0 bottom-0 transform translate-x-10 translate-y-10 h-32 w-32 opacity-25 text-gray-900 fill-current`}
`;

export default ({ isXs = false }) => {
  if (isXs) return <LeaseBusinessMobileView />;
  const myRef = useRef();
  const { t } = useTranslation();

  return (
    <BgWrapper>
      <div ref={myRef} id="lease-business">
        <Container>
          <ContentWithVerticalPadding>
            <Row>
              <TextColumn>
                <BgTitle text={t("business.lease-of-pc.heading")} />
                <Description>
                  {t("business.lease-of-pc.description")}
                </Description>
                <FeatureList>
                  {t("business.lease-of-pc.content", {
                    returnObjects: true,
                  }).map((feature, index) => (
                    <Feature key={index}>
                      <FeatureIcon />
                      <FeatureText>{feature}</FeatureText>
                    </Feature>
                  ))}
                </FeatureList>

                {/* Contact Section */}
                <ContactInfo>
                  <Heading2>Contact</Heading2>
                  <ContactText>{t("business.lease-of-pc.contact")}</ContactText>
                </ContactInfo>
              </TextColumn>

              <ImageColumn>
                <ImageContainer>
                  <Image src={leaseBusinessDiagram} />
                  <Offsetbackground />
                  {<ImageDecoratorBlob />}
                </ImageContainer>
              </ImageColumn>
            </Row>
          </ContentWithVerticalPadding>
        </Container>
      </div>
    </BgWrapper>
  );
};
